module.exports = __webpack_public_path__ + "static/video-d6796e33523797652919fc15329f5128.png";